// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1PuJX","title":"styles_title__W84or","imageContainer":"styles_imageContainer__1P0g8","image":"styles_image__244cH","point":"styles_point__1PEoj"};